import { cn } from "@/lib/utils";

const dotColors = {
  primary: "bg-primary",
  background: "bg-background",
  current: "bg-current",
};

interface LoadingDotsProps {
  className?: string;
  color?: keyof typeof dotColors;
}

export function LoadingDots({
  className,
  color = "primary",
}: LoadingDotsProps) {
  return (
    <div
      className={cn(
        `inline-flex w-7 h-5 gap-0.5 justify-center items-center bg-transparent`,
        className,
      )}
    >
      <span className="sr-only">Loading...</span>
      <div
        className={`flex-1 size-2 ${dotColors[color]} rounded-full animate-bounce [animation-delay:-0.3s]`}
      />
      <div
        className={`flex-1 size-2 ${dotColors[color]} rounded-full animate-bounce [animation-delay:-0.15s]`}
      />
      <div
        className={`flex-1 size-2 ${dotColors[color]} rounded-full animate-bounce`}
      />
    </div>
  );
}
